<template>
    <div ref="talkjs" style="width: 90%; margin: 30px; height: 500px">
      <i>Loading chat...</i>
    </div>
</template>

<script>
import Talk from 'talkjs';
export default {
  name: "vue-talk",
  async mounted() {
    await Talk.ready
    const me = new Talk.User({
      id: "27729192",
      name: "Alain MUCYO",
      email: "alainmucyo3@gmail.com",
      photoUrl: "https://alainmucyo.netlify.app/img/pp.jpeg",
      //The welcomeMessage is the first message any other user will see when they start a chat with this user
      role: "booker"
    })
    const other = new Talk.User({
      id: '6543211',
      name: 'Sebastian',
      email: 'Sebastian@example.com',
      photoUrl: 'https://talkjs.com/images/avatar-5.jpg',
      role: 'default',
    });
    const talkSession = new Talk.Session({
      appId: 'tH4Su3WF',
      me: me,
    });
    const conversation = talkSession.getOrCreateConversation(
        Talk.oneOnOneId(me, other)
    );
    conversation.setParticipant(me);
    conversation.setParticipant(other);

    const inbox = talkSession.createInbox();
    inbox.select(conversation);

    await inbox.mount(this.$refs.talkjs);
  },

}
</script>

<style scoped>

</style>